import { Component, OnInit } from '@angular/core';
import {LoadingService} from '../../services/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

    public showing = 0;

    constructor(
        private loadingService: LoadingService
    ) { }

    ngOnInit() {
        this.loadingService.getObservable().subscribe(show => {
            if (show) {
                this.showing++;
            } else {
                this.showing--;
            }
        });
    }

}
